import request from '@/services/interceptor.js'

export const get_parametri_azienda = () => {
    return request({
        url: '/parametri-azienda',
        method: 'get',
        loadingBar: true
    })
}

export const salva_parametri_azienda = (dati) => {
    return request({
        url: '/parametri-azienda',
        method: 'put',
        data: dati,
        loadingBar: true
    })
}
